import axios from 'axios';

axios.defaults.baseURL = 'https://portfolio-js.b.goit.study/api/';

export async function fetchReviews() {
  const response = await axios.get('reviews');
  return response.data;
}
